import React, { useLayoutEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import { HyunDaiMarineEngine } from "./hyundai-marineEngine";
import { HyundaiGeneratorEngine } from "./hyundai-generater";
import { Products } from "../../products";
export interface Props {setData : Function}
export const Hyundai:React.FC<Props> = ({setData}) => {
    const location = useLocation()
    const path = location.pathname.split('/')
    const {product} = useParams()
    useLayoutEffect(()=>{
        if(path[2] === 'marineEngine' && product){setData((prev:any)=>({...prev, title_2_kr : '선박용 엔진', title_2_en : 'Marine Engine', className_2 : 'engine_view'}))}
        else if(path[2] === 'marineEngine' && !product){setData((prev:any)=>({...prev, title_2_kr : '선박용 엔진', title_2_en : 'Marine Engine', className_2 : 'engine'}))}
        else if(path[2] === 'generatorEngine' && product){setData((prev:any)=>({...prev, title_2_kr : '발전기 엔진', title_2_en : 'Generator Engine', className_2 : 'engine_view'}))}
        else if(path[2] === 'generatorEngine' && !product){setData((prev:any)=>({...prev, title_2_kr : '발전기 엔진', title_2_en : 'Generator Engine', className_2 : 'engine'}))}
    }, [location])
    return(
        <>
        {path[2]==='marineEngine' && !product ? <HyunDaiMarineEngine/> : ''}
        {path[2]==='marineEngine' && product ? <Products/> : ''}
        {path[2]==='generatorEngine' && !product ? <HyundaiGeneratorEngine/> : ''}
        {path[2]==='generatorEngine' && product ? <Products/> : ''}
        </>
    )
}